// prettier-ignore
const breakpoints = [
  "40em",
  "52em",
  "64em"
];

// prettier-ignore
const space = [
  0,
  4,
  8,
  12,
  16,
  32,
  64,
  128,
  256,
  512
];

// prettier-ignore
const fontSizes = [
  12,
  14,
  16,
  20,
  24,
  32,
  48,
  64,
  72
];

const shadows = {
  primary: "0 3px 24px 6px rgba(194, 188, 194, 1)",
  secondary: "0 2px 6px 1px rgba(194, 188, 194, 1)",
  tertiary:
    "0 1px 3px 0 rgba(50, 50, 93, 0.15), 0 4px 6px 0 rgba(112, 157, 199, 0.15)",
};

const radii = {
  none: 0,
  sm: 2,
  default: 4,
  lg: 8,
  full: 999999,
};

module.exports = {
  breakpoints,
  space,
  fontSizes,
  shadows,
  radii,
};



// WEBPACK FOOTER //
// ../shared/optilit-themes/src/common.js